import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@shigo-ui/ui';

import { useReturnNavigation, type ReturnFallbackInput } from '../../lib/returnNavigation';

/**
 * The page-header Back control: a router Link to the page this one was opened from (see
 * `useReturnNavigation`), or to `fallback`. Modified clicks open a new tab as with any link.
 */
export function ReturnBackLink<TTo extends string | undefined>({
  fallback,
  label,
}: {
  fallback: ReturnFallbackInput<TTo>;
  label: string;
}) {
  const { link, markReturn } = useReturnNavigation(fallback);
  return (
    <Button asChild variant="outline" size="icon">
      <Link
        {...(link as Parameters<typeof Link>[0])}
        aria-label={label}
        onClick={(event) => {
          // Only a same-tab navigation is a return; a new tab starts its own trail.
          if (event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
            markReturn();
          }
        }}
      >
        <ArrowLeft className="size-4" aria-hidden="true" />
      </Link>
    </Button>
  );
}
